export default __webpack_public_path__ + "8777af0a90df452eeecf107abd0a96fa.png";